document.addEventListener("DOMContentLoaded", initTipPage)
document.addEventListener("turbolinks:load", initTipPage)

function initTipPage() {
  const form = document.getElementById("tip-form")
  if (!form) return

  const isSuperAdminPreview = form.dataset.superAdminPreview === "true"
  const stripeKey = form.dataset.stripeKey
  const stripe = isSuperAdminPreview ? null : Stripe(stripeKey)

  let elements = null
  let currentAmount = 500 // default $5 in cents

  function resetPresetButtons() {
    document.querySelectorAll(".amount-preset").forEach(button => {
      button.classList.remove("btn-secondary")
      button.classList.add("btn-outline-secondary")
    })
  }

  function mountPaymentElement(amountCents) {
    if (isSuperAdminPreview) return

    const container = document.getElementById("payment-element")
    if (!container) return

    container.innerHTML = ""

    elements = stripe.elements({
      mode: "payment",
      amount: amountCents,
      currency: "usd",
      appearance: {
        theme: "night",
        variables: { colorPrimary: "#e94560" }
      }
    })

    const paymentEl = elements.create("payment")
    paymentEl.mount("#payment-element")
  }

  // --- Amount preset buttons ---
  document.querySelectorAll(".amount-preset").forEach(btn => {
    btn.addEventListener("click", () => {
      resetPresetButtons()
      btn.classList.remove("btn-outline-secondary")
      btn.classList.add("btn-secondary")
      const dollars = parseInt(btn.dataset.amount)
      currentAmount = dollars * 100
      document.getElementById("tip-amount").value = dollars
      mountPaymentElement(currentAmount)
    })
  })

  document.getElementById("tip-amount").addEventListener("change", e => {
    const dollars = parseFloat(e.target.value) || 0
    if (dollars >= 1) {
      currentAmount = Math.round(dollars * 100)
      resetPresetButtons()
      mountPaymentElement(currentAmount)
    }
  })

  // --- Character counter ---
  const messageArea = document.getElementById("tip-message")
  const charCount = document.getElementById("char-count")
  const errorsDiv = document.getElementById("payment-errors")
  if (messageArea && charCount) {
    messageArea.addEventListener("input", () => {
      charCount.textContent = `${messageArea.value.length} / 300 characters`
    })
  }

  // --- Initial mount ---
  mountPaymentElement(currentAmount)

  // --- Form submit ---
  form.addEventListener("submit", async e => {
    e.preventDefault()
    const submitBtn = document.getElementById("submit-tip")
    const statusDiv = document.getElementById("tip-status")

    const tipperName = (document.getElementById("tipper-name") || document.querySelector("input[name='tip[tipper_name]']"))?.value?.trim()
    if (!tipperName) {
      errorsDiv.textContent = "Please enter your name."
      return
    }

    const dollarInput = document.getElementById("tip-amount").value
    const dollars = parseFloat(dollarInput) || 0
    if (dollars < 1) {
      errorsDiv.textContent = "Minimum tip is $1.00."
      return
    }
    currentAmount = Math.round(dollars * 100)

    submitBtn.disabled = true
    submitBtn.textContent = "Processing..."
    errorsDiv.textContent = ""

    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

    const res = await fetch("/tips", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken || ""
      },
      body: JSON.stringify({
        tip: {
          tipper_name: tipperName,
          tipper_email: (document.getElementById("tipper-email") || document.querySelector("input[name='tip[tipper_email]']"))?.value?.trim(),
          amount_cents: currentAmount,
          message: document.getElementById("tip-message").value.trim(),
          voice_id: document.getElementById("voice-select").value
        }
      })
    })

    const data = await res.json()
    if (!res.ok || data.error) {
      errorsDiv.textContent = data.error || "Something went wrong. Please try again."
      submitBtn.disabled = false
      submitBtn.textContent = isSuperAdminPreview ? "Send Test Tip" : "Send Tip"
      return
    }

    if (isSuperAdminPreview) {
      statusDiv.innerHTML = '<div class="alert alert-success">🍕 Test tip sent! Your voice message will play on the stream shortly.</div>'
      form.reset()
      charCount && (charCount.textContent = "0 / 300 characters")
      submitBtn.disabled = false
      submitBtn.textContent = "Send Test Tip"
    } else {
      // Confirm payment with Stripe
      const { error } = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: window.location.href,
          payment_method_data: {
            billing_details: { name: tipperName }
          }
        },
        redirect: "if_required"
      })

      if (error) {
        errorsDiv.textContent = error.message
        submitBtn.disabled = false
        submitBtn.textContent = "Send Tip"
      } else {
        statusDiv.innerHTML = '<div class="alert alert-success">🍕 Tip sent! Your voice message will play on the stream shortly.</div>'
        form.reset()
        charCount && (charCount.textContent = "0 / 300 characters")
        submitBtn.disabled = false
        submitBtn.textContent = "Send Tip"
        mountPaymentElement(currentAmount)
      }
    }
  })
}
